<template>
  <div class="container">
    <div class="header">
      <p>第一部分&nbsp;&nbsp;视觉健康问卷</p>
    </div>
    <div id="progressContainerTop">
      <p>{{ pw + "%" }}</p>
      <div id="progressContentTop" :style="`width:${pw}%`"></div>
    </div>
    <div id="questionContainer">
      <span>{{ updateQuestion.subject }}</span>
      <div class="inputContainer" v-if="updateQuestion.isMultipleChoice === 3">
        <input
          v-model.number="inputValue"
          placeholder="请在此输入镜片度数"
          type="number"
        />
      </div>
      <div
        id="progressContainer"
        @click="onScroll"
        v-if="updateQuestion.isMultipleChoice === 4"
      >
        <div id="progressContent" :style="`width:${progressWidth}%`"></div>
        <span
          >{{ updateQuestion.type[0] }}({{ this.progressWidth }}%) /
          {{ updateQuestion.type[1] }}({{ 100 - this.progressWidth }}%)</span
        >
      </div>
      <ul>
        <li
          @click="onSelect(index)"
          v-for="(q, index) of updateQuestion.anwser"
          :key="index"
        >
          <div class="anwserContainer">
            <div v-show="selectNum.indexOf(index) != -1"></div>
            <span>{{ q }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="footer" @click="onNext" :style="`background:${btnColor}`">
      {{ buttonStr }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Questionnaire",
  inject: ["reload"],
  data() {
    return {
      //进度条长度
      pw: 0,
      text: "",
      //底部按钮的背景色
      btnColor: "",
      //当前做到第几题
      questionNum: 0,
      //当前选择的是第几个选项
      selectNum: [0],
      //底部按钮中间的文字
      buttonStr: "下一题",
      //眼镜度数
      inputValue: "",
      //答案
      resultArr: [],
      //比重条的宽
      progressWidth: 50,
      //题库
      questionArr: [
        {
          subject: "第1题.您采用哪种镜片矫正视力？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: [
            "A.框架眼镜",
            "B.软性隐形眼镜",
            "C.硬性角膜塑形镜",
            "D.其他",
          ],
        },
        {
          subject: "第2题.您配镜是为了何种矫正目的？",
          isMultipleChoice: 2,
          anwser: [
            "A.近视",
            "B.散光",
            "C.远视",
            "D.老花",
            "E.斜视",
            "F.弱势",
            "G.其他",
          ],
        },
        {
          subject: "第3题.您的镜片度数为？",
          isMultipleChoice: 3,
          anwser: [],
        },
        {
          subject: "第4题.您初次戴镜时间？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: [
            "A.小学二年级及以前",
            "B.小学三年级至初中前",
            "C.初中",
            "C.高中",
            "C.大学",
            "C.工作后",
          ],
        },
        {
          subject: "第5题.您最近一次验光配镜是在？",
          isMultipleChoice: 1,
          anwser: ["A.近6个月", "B.6个月~1年前", "C.1年~2年前", "D.2年前"],
        },
        {
          subject: "第6题.您对下列眼镜应用知识是否知晓？",
          isMultipleChoice: 2,
          anwser: [
            "A.眼镜验配分为足矫和欠矫",
            "B.眼镜验配应测量瞳距和瞳高",
            "C.并非只有屈光不正（近视、远视、散光等）的时候才进行眼镜验配",
            "D.某些眼镜具有特殊防护功能，如偏光眼镜、变色眼镜、电脑防护功能眼镜等",
            "E.隐形眼镜验配一定要在有医疗器械许可认证的单位进行",
            "F.框架眼镜的定配需要质量检测",
            "G.不知晓上述内容",
          ],
        },
        {
          subject: "第7题.即使戴上眼镜，还是存在看不清的情况？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第8题.在户外明亮环境下，看近看远切换时，不能立刻看清？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第9题. 写字时，字体之间的间距不相等？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第10题.在没有条格的纸上写字时，一行字会向上/向下偏斜？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.向上偏斜", "B.向下偏斜"],
        },
        {
          subject: "第11题.阅读文字时经常串行，从这一行串到下一行？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第12题.阅读时，头很明显地随着视线摆动？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第13题.阅读时，用手指着逐字读，会感觉读起来更容易些？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第14题.阅读时，嘴跟着默读会更利于理解/记忆文字的内容？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第15题.看手机时喜欢用单眼看？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第16题.无法适应3D游戏，易头晕、恶心？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第17题.坐车时看手机易晕车？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第18题.做细致手工活如针线活时，感到困难，眼睛易疲劳？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第19题.雨天的夜晚，视力有明显下降？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第20题.眼睛经常出现干涩、摩擦感、瘙痒、疼痛、流泪的症状？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第21题.您平均每天有多长的户外活动时间？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.基本没有", "B.0~1小时", "C.1~2小时", "D.2小时以上"],
        },
        {
          subject: "第22题.您平均每天使用多长时间的电子产品？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: [
            "A.0~2小时",
            "B.2~4小时",
            "C.4~5小时",
            "D.5~6小时",
            "E.6小时以上",
          ],
        },
        {
          subject: "第23题.您每天近距离用眼时长的占比？",
          //是否是多选
          isMultipleChoice: 4,
          anwser: [],
          type: ["电子设备", "纸质材料"],
        },
        {
          subject: "第24题.使用电子设备时各显示占比？",
          //是否是多选
          isMultipleChoice: 4,
          anwser: [],
          type: ["静态显示", "动态显示"],
        },
        {
          subject: "第25题.您的就寝时间是？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: [
            "A.21:00之前",
            "B.21:00-22:00",
            "C.22:00-23:00",
            "D.23:00-00:00",
            "E.00:00以后",
          ],
        },
        {
          subject: "第26题.下列行为中，您有哪些 ？",
          //是否是多选
          isMultipleChoice: 2,
          anwser: [
            "A.长时间近距离看东西或玩手机",
            "B.在走路时玩手机",
            "C.躺在床上看手机",
            "D.在运动的车厢中看手机",
            "E.使用手机的自动亮度功能",
            "F.使用电子设备的护眼模式",
            "G.在光线昏暗或过亮的环境中用眼",
            "H.学习、工作间隙定期休息眼睛",
            "I.视力等视觉健康检查一年进行一次",
            "J.无上述行为",
          ],
        },
        {
          subject: "第27题.您听说过下列哪些视觉健康相关的病症？",
          //是否是多选
          isMultipleChoice: 2,
          anwser: [
            "A.近视、远视、散光",
            "B.视疲劳、干眼",
            "C.阅读障碍",
            "D.弱视",
            "E.斜视",
            "F.多动症、自闭症",
            "G.未听说过上述内容",
          ],
        },
        {
          subject: "第28题.您使用过哪些护眼产品？",
          //是否是多选
          isMultipleChoice: 2,
          anwser: [
            "A.防蓝光眼镜",
            "B.蒸汽眼罩",
            "C.护眼贴",
            "D.护眼灯",
            "E.眼药水",
            "F.其他",
            "G.未使用过护眼产品",
          ],
        },
        {
          subject: "第29题.您使用滴眼液的目的是？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: [
            "A.用于缓解视疲劳",
            "B.用于缓解眼干、眼涩、眼痛",
            "C.其他目的",
          ],
        },
        {
          subject: "第30题.睡觉时，是否有夜灯通宵照明 ？",
          //是否是多选
          isMultipleChoice: 1,
          anwser: ["A.是", "B.否"],
        },
        {
          subject: "第31题.您的父母是否有下列视觉健康问题？",
          //是否是多选
          isMultipleChoice: 2,
          anwser: [
            "A.近视",
            "B.散光",
            "C.远视",
            "D.老花",
            "E.斜视",
            "F.弱视",
            "G.色盲、色弱",
            "H.其他",
            "I.没有视觉健康问题",
          ],
        },
        {
          subject: "第32题.您想要了解哪些关于视觉健康的科普",
          //是否是多选
          isMultipleChoice: 2,
          anwser: [
            "A.近视防控",
            "B.斜弱视治疗与康复",
            "C.缓解视疲劳",
            "D.老花、白内障等老化类疾病",
            "E.阅读障碍、多动症等儿童发育类疾病",
          ],
        },
      ],
    };
  },
  computed: {
    updateQuestion() {
      return this.questionArr[this.questionNum];
    },
  },
  methods: {
    onScroll(e) {
      this.progressWidth = Math.floor((e.offsetX / 200) * 100);
      this.selectNum = [this.progressWidth, 100 - this.progressWidth];
    },
    onNext() {
      if (this.$store.state.global.isLoadingShow) {
        return;
      }
      //存储答案
      //第三题特殊处理
      if (this.questionArr[this.questionNum].isMultipleChoice === 3) {
        if (!this.inputValue) {
          this.$dialog.alert({
            message: "请输入您的镜片度数",
          });
          return;
        }
        this.resultArr.push([this.inputValue]);
      } else {
        this.resultArr.push(this.selectNum);
      }

      //重置
      this.selectNum = [0];
      this.progressWidth = 0;

      if (this.questionNum === this.questionArr.length - 1) {
        this.$store.state.global.isLoadingShow = true;
        //上传结果
        this.$axios({
          url:
            this.$store.state.global.padUrl +
            "/visualplatpad/detector-report/save",
          method: "post",
          data: {
            globalId: this.$store.state.global.globalId,
            testType: 99,
            testResult: JSON.stringify(this.resultArr),
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.global.token,
            serverFlag: "",
            dsName: "",
            "content-type": "application/json",
          },
        }).then(
          (response) => {
            this.$store.state.global.isLoadingShow = false;
            //跳转页面
            this.$router.push("/commonDescription");
          },
          (error) => {
            this.$store.state.global.isLoadingShow = false;
            this.$dialog
              .alert({
                message: "问卷提交失败，请联系管理员",
              })
              .then(() => {
                //跳转页面
                this.reload();
              });
          }
        );

        return;
      }
      this.questionNum++;
      this.pw = Math.floor(((this.questionNum + 1) / 32) * 100);
      if (this.questionArr[this.questionNum].isMultipleChoice === 4) {
        //4比重题
        this.selectNum = [this.progressWidth, 100 - this.progressWidth];
      }
      if (this.questionNum === this.questionArr.length - 1) {
        this.btnColor = "#FEC002";
        this.buttonStr = "进入视知觉测试";
      }
    },
    onSelect(index) {
      if (this.questionArr[this.questionNum].isMultipleChoice === 1) {
        //判断是否是多选，1是单选，2是多选，3是输入,4比重题
        this.selectNum = [index];
      } else if (this.questionArr[this.questionNum].isMultipleChoice === 2) {
        if (this.selectNum.indexOf(index) != -1) {
          this.selectNum.splice(this.selectNum.indexOf(index), 1);
        } else {
          this.selectNum.push(index);
        }
      }
    },
  },
  mounted() {
    this.$store.state.global.isTrans = false;
    this.resultArr = [];
    this.btnColor = "#297BFF";
    //判断是否选择了戴镜，如果戴镜，则从0开始，反之7开始
    if (this.$store.state.global.onEye === 1) {
      //1是戴镜
      this.questionNum = 0;
      this.pw = Math.floor(((this.questionNum + 1) / 32) * 100);
    } else {
      //不戴
      this.questionNum = 6;
      this.pw = Math.floor(((this.questionNum + 1) / 32) * 100);
      this.resultArr[(null, null, null, null, null, null)];
    }
  },
};
</script>

<style scoped>
ul {
  height: 60%;
  overflow: auto;
}
.container {
  background: rgb(237, 241, 248);
}
p {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 4vw;
  font-weight: bold;
}
#progressContainerTop {
  width: 90vw;
  height: 4vw;
  background: rgb(216, 216, 216);
  border-radius: 3vw;
  position: absolute;
  left: 5vw;
  top: 12%;
}
#progressContentTop {
  height: 4vw;
  border-radius: 3vw;
  text-align: center;
  background-color: rgb(41, 123, 255);
}
#progressContainerTop p {
  position: absolute;
  left: 50%;
  top: 53%;
  transform: translate(-50%, -50%);
  font-size: 3vw;
  color: white;
}
#progressContainer {
  width: 200px;
  height: 4vw;
  background: rgb(216, 216, 216);
  border-radius: 3vw;
  margin: 20vw auto;
  /* margin-left: 12vw;
        margin-top: 20vw; */
  position: relative;
}
#progressContainer span {
  font-size: 3vw;
  display: block;
  text-align: center;
  margin-top: 3vw;
}
#progressContent {
  height: 4vw;
  /* color: rgb(117, 44, 44); */
  border-radius: 3vw;
  text-align: center;
  /* width: 50%; */
  background-color: rgb(41, 123, 255);
}
.inputContainer {
  width: 100vw;
  position: relative;
}
.inputContainer input {
  width: 50vw;
  position: absolute;
  left: 15vw;
  top: 10vw;
  font-size: 4vw;
  height: 10vw;
}
#questionContainer {
  background: white;
  position: absolute;
  top: 20%;
  left: 3vw;
  width: 94vw;
  height: 80%;
  border-radius: 3vw;
}
#questionContainer span:nth-child(1) {
  margin-left: 15vw;
  line-height: 8vw;
  font-size: 4vw;
  width: 70vw;
  display: block;
  margin-top: 5vw;
}
.anwserContainer {
  margin-top: 2vw;
  width: 70vw;
  height: 8vw;
  position: relative;
  margin-left: 15vw;
}
.anwserContainer span {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  font-size: 3vw;
}
.anwserContainer div {
  position: absolute;
  top: 0;
  left: 0;
  background: rgb(41, 123, 255);
  width: 80vw;
  height: 8vw;
  margin-left: -5vw;
  border-radius: 5vw;
}
.footer {
  position: absolute;
  left: 50%;
  top: 85%;
  transform: translate(-50%, 0%);

  width: 80vw;
  height: 11vw;
  border-radius: 5vw;
  text-align: center;
  line-height: 11vw;
  font-size: 4vw;
  background: rgb(41, 123, 255);
  color: white;
}
.header {
  width: 100vw;
  color: rgb(128, 128, 128);
  position: absolute;
  left: 0;
  top: 2%;
  height: 12%;
}
</style>
